/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Benefits_LabelInputs */

const en_directory_promotion_benefits_label = /** @type {(inputs: Directory_Promotion_Benefits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsored label`)
};

const zh_directory_promotion_benefits_label = /** @type {(inputs: Directory_Promotion_Benefits_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助标识`)
};

/**
* | output |
* | --- |
* | "Sponsored label" |
*
* @param {Directory_Promotion_Benefits_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_benefits_label = /** @type {((inputs?: Directory_Promotion_Benefits_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Benefits_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_benefits_label(inputs)
	return zh_directory_promotion_benefits_label(inputs)
});
export { directory_promotion_benefits_label as "directory.promotion.benefits.label" }